import { apiClient as api, encodePrn } from '@plerionhq/design-system';
import { useQuery } from '@tanstack/react-query';

type AssetRawDataResponse = {
  data: {
    rawData: { data: Record<string, unknown> };
    meta: { region: string; integrationId: string; provider: string };
  };
};

export function useGetAssetRawData(assetId: string | undefined) {
  const encodedPrn = assetId ? encodePrn(assetId) : '';
  // Use the same query key as assets/findings/dspm so we share the cache.
  return useQuery({
    queryKey: ['getAssetRawData', encodedPrn],
    queryFn: async () => {
      const res = await api.get<AssetRawDataResponse>(
        `/api/inventory/tenant/raw-assets/${encodedPrn}`,
      );
      return res.data;
    },
    enabled: encodedPrn !== '',
  });
}
